<div [formGroup]="parentForm">
    <div *ngIf="showFileBrowser">
        <div class="row">
            <div class="col-md-12">

                <div class="form-group ">
                    <div class="input-group">

                        <input name="Archivo" title="" [formControlName]="inputId" class="form-control" style="font-style:italic" [placeholder]="getContentPlaceHolder()" [ngClass]="displayFieldCssUploader()" [id]="inputId" readonly
                               type="text">

                        <span class="input-group-btn">

                            <input class="form-control" id="fileLoader" [accept]="validTypesToString" onclick="value = null"
                                   style="display: none;" type="file" (change)="handleFileInput($event.target.files)" #file>
                                <button name="btnAddArchivo" class="btn btn-list btn-secondary ms-1" type="button"
                                          title="Elegir un {{ fileTitle }}" (click)="file.click()"><i class="fa fa-upload"></i>
                                </button>
                            <button name="btnCleanArchivo" class="btn btn-list btn-secondary-clean" type="button"
                                    title="Eliminar {{ fileTitle }} seleccionado" [disabled]="isLoadDisabled" (click)="onCleanButton()">
                                <i class="fa fa-times"></i>
                            </button>
                        </span>

                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalidRequiredUploader()">
                            Debe especificar un archivo
                        </div>

                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalidSizeLimitServerUploader()">
                            Tamaño superior a {{ megaSizeLimit }} MB
                        </div>

                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalidExtensionUploader()">
                            Tipo de archivo no admitido
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-md-3">
                <div *ngIf="!isLoadDisabled" class="btn-group">
                    <button class="btn btn-secondary btn-sm" type="button" [disabled]="isLoadDisabled" title="Cargar {{ fileTitle }}" (click)="onUpload()"><i class="fa fa-upload"></i> Cargar</button>
                </div>

                <div *ngIf="showCancelButton()" class="btn-group">
                    <button class="btn btn-secondary btn-sm" type="button" title="Cancelar" (click)="onCancel()"><i class="fa fa-times"></i> Cancelar</button>
                </div>
            </div>
            <div class="col-md-9">
                <div *ngIf="uploadedFile?.Progress" class="progress-bar" role="progressbar" [style.width.%]="uploadedFile?.Progress" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                    {{ uploadedFile?.Progress }}%
                </div>
            </div>
        </div>
    </div>
    
    <div *ngIf="!showFileBrowser" class="row">
        <div *ngIf="!uploadedFile?.MarkToDelete" class="col-md-12">
            <div class="table-responsive">
                <table class="table table-sm">
                    <thead>
                        <tr *ngIf="getSizeKb() !== null">
                            <th style="width: 14%" *ngIf="!readOnly || !readOnlyDownload"></th>
                            <th style="width: 16%"> Tamaño </th>
                            <th style="width: 70%"> Nombre Archivo </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngIf="getSizeKb() === null"><td class="empty-grid">No hay ningún documento asociado</td></tr>
                        <tr *ngIf="getSizeKb() !== null">
                            <td *ngIf="!readOnly || !readOnlyDownload">
                                <div class="btn-group" *ngIf="!readOnlyDownload">
                                    <button *ngIf="isDocumentoDescargable" (click)="onDownload()" type="button" title="Descargar {{ fileTitle }}"
                                            class="btn btn-sm btn-info">
                                        <span class="fa fa-download"></span>
                                    </button>
                                </div>

                                <div class="btn-group" *ngIf="!readOnly">
                                    <button (click)="onDelete()" type="button" title=" {{ deleteTitle }}"
                                            class="btn btn-sm btn-danger">
                                        <span class="fa fa-remove"></span>
                                    </button>
                                </div>
                            </td>
                            <td>{{ getSizeKb() | number:'1.0-2':'es' }} kB</td>
                            <td>{{ uploadedFile?.Name }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
